



































import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import { debounce } from 'lodash';

import ThreePanelConditionCategoryItem from './three-panel-condition-category-item.vue';
import DataTable from '@/components/datatable/datatable';
import { FormattersTypes } from '@/services/types/formatter'

@Component({
  components: {
    DataTable,
    ThreePanelConditionCategoryItem
  }
})
export default class ThreePanelConditionCategoryList extends Vue {
  @Prop()
  selectedBrands: any[];

  @Prop()
  brandSelectAllIndex: any[];

  @Prop()
  selectedKeysIndex: any[];

  @Prop()
  data: any[];

  @Prop()
  selected: any[];
  
  @Prop()
  focusedItem: any

  @Prop()
  focused: string;

  @Prop({default: true})
  firstPanel: boolean;

  @Prop({default: false})
  prefix: string;

  @Emit('select-all')
  onSelectAll(item: any) {}

  @Emit('update:focusedItem')
  onUpdateFocusedItem(item: any) {}

  @Emit('update:focused')
  onUpdateFocused(item: any) {}

  autoVirtualScrollAt: number = 50;

  get noEvents() {
    return this.data.length < this.autoVirtualScrollAt;
  }

  toggle(item: any) {
    this.$emit('toggle', item);
  }

  @Watch('selectedKeys', { deep: true })
  onSelectedKeysChanged(value: any[]) {
    this.bus.emit(this.prefix + '-selected-keys', value);
  }

  @Watch('selectedBrands', { deep: true })
  onSelectedBrandsChanged(value: any[]) {
    this.bus.emit(this.prefix + '-selected-brands', value);
  }

  @Watch('focused') 
  onFocusedChanged(value: string) {
    this.bus.emit(this.prefix + '-focused', value);
  }

  get headers() {
    return [
      {
        text: 'name',
        align: 'left',
        value: 'name',
        sortable: false
      },
    ]
  }

  get formatters(){
    return {
      name: ({ vtag: h, data }: FormattersTypes) => {
        const categoryItem = h(ThreePanelConditionCategoryItem, {
          attrs: {
            selectedBrands: this.selectedBrands,
            brandSelectAllIndex: this.brandSelectAllIndex,
            selectedKeysIndex: this.selectedKeysIndex,
            focused: this.focused,
            item: data,
            prefix: this.prefix,
            firstPanel: this.firstPanel,
            noEvents: this.noEvents
          },
          on: {
            toggle: (item: any) => {
              this.toggle(item)
            },
            'select-all': (item: any) => {
              this.onSelectAll(item);
            }
          }
        });

        return h('td', 
          {
            class: [ this.focused, data.$revision ],
            style: { 
              height: '40px',
              padding: '0',
            },
          }, 
          [ categoryItem ]
        );
      }
    }
  } 

  searchBrand: string = '';
  pSearchBrand: string = '';

  @Watch('searchBrand')
  onSearchBrandChaged(value: string) {
    this.setSearchBrandDebounced(value);
  }

  get setSearchBrandDebounced() {
    return debounce(this.setSearchBrand, 300);
  }

  setSearchBrand(value: string) {
    this.pSearchBrand = value;
  }

  get items() {
    let result = [];
    if (this.pSearchBrand) {
      result = this.data.filter((item: any) => {
        return item.name.toLowerCase().includes(this.searchBrand.toLowerCase())
      }).slice(0, 100);
    } else {
      result = this.data;
    }
    return result;
  }
}
